var _defs, _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgAdornment(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#0a0a0a;fill-rule:evenodd;isolation:isolate;opacity:.54;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    className: "d",
    d: "M42,12c1.1,0,2,.9,2,2v5.06l.18,.16c2.35,2.19,3.82,5.31,3.82,8.78,0,6.63-5.37,12-12,12-3.47,0-6.59-1.47-8.78-3.82l-.16-.18H14c-1.1,0-2-.9-2-2V14c0-1.1,.9-2,2-2h28Zm-6,6c-5.52,0-10,4.48-10,10s4.48,10,10,10,10-4.48,10-10-4.48-10-10-10Zm-11.31,5.97v.03H14v10h11.61l.03,.06c-1.04-1.78-1.64-3.85-1.64-6.06,0-1.41,.24-2.77,.69-4.03Zm11.31,2.03c1.1,0,2,.9,2,2s-.9,2-2,2-2-.9-2-2,.9-2,2-2Zm-6,0c1.1,0,2,.9,2,2s-.9,2-2,2-2-.9-2-2,.9-2,2-2Zm12,0c1.1,0,2,.9,2,2s-.9,2-2,2-2-.9-2-2,.9-2,2-2Zm0-12H14v4h15.38c1.9-1.27,4.17-2,6.62-2,2.21,0,4.28,.6,6.06,1.64l-.06-.03v-3.61Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdornment);
export default __webpack_public_path__ + "static/media/adornment.617477b3.svg";
export { ForwardRef as ReactComponent };